<div class="aside-logo flex-column-auto" id="kt_aside_logo">
    <div
        *ngIf="currentTheme.baseSettings.menu.allowAsideMinimizing"
        id="kt_aside_toggle"
        data-kt-toggle="true"
        data-kt-toggle-state="active"
        data-kt-toggle-target="body"
        data-kt-toggle-name="aside-minimize"
        class="btn btn-icon px-0 btn-active-color-primary aside-toggle mr-10"
    >
        <span class="icon-Property-3chevron-double-left rotate-180">
        </span>
    </div>
    <default-logo></default-logo>
</div>
